import {
  ApplicationType,
  DataSourceType,
} from "@/views/customize/data-sources/data/model";

export type FindingWAxisType =
  | "None"
  | "Employee"
  | "EmployeeSender"
  | "EmployeeReceiver"
  | "Severity"
  | "Person"
  | "PersonSender"
  | "PersonReceiver"
  | "PersonalAddress"
  | "ExternalSender"
  | "ExternalReceiver"
  | "NonPrivatePersonSender"
  | "NonPrivatePersonReceiver"
  | "ContentLabel"
  | "EntityLabel"
  | "EventLabel"
  | "LabelSeverityLow"
  | "LabelSeverityMedium"
  | "LabelSeverityHigh"
  | "Application"
  | "Insight"
  | "Folder"
  | "OrganizationSender"
  | "OrganizationReceiver"
  | "Topic"
  | "ProcessInstance"
  | "Group"
  | "NamedEntity"
  | "UntrustedEmployeeReceiver"
  | "UntrustedOrganization"
  | "UntrustedPersonalAddress"
  | "ObjectContainer"
  | "ObjectLabel"
  | "MIPLabel"
  | "MIPAction"
  | "MIPInternalLabel"
  | "PersonSenderType"
  | "PersonReceiverType"
  | "EmployeeSenderType"
  | "EmployeeReceiverType"
  | "EmployeeType"
  | "ExternalReceiverType"
  | "OrganizationReceiverType"
  | "FolderType"
  | "PersonalAddressType"
  | "NonPrivatePersonSenderType"
  | "NonPrivatePersonReceiverType"
  | "UntrustedEmployeeReceiverType"
  | "UntrustedOrganizationType"
  | "UntrustedPersonalAddressType"
  | "InfoTypeLabel"
  | "AggObject"
  | "AggObjectType";

export type FindingZAxisType =
  | "Week"
  | "Month"
  | "Total"
  | "Session"
  | "Ongoing";

export type FindingType =
  | "sp_site_permission"
  | "internal_exposure"
  | "mass_exposure"
  | "external_exposure"
  | "external_mass_exposure"
  | "personal_address_exposure"
  | "sensitive_information"
  | "sensitive_db_obj"
  | "sensitive_storage_obj"
  | "sensitive_data_detected_for_unprotected"
  | "anomaly_ip_detected"
  | "top_risky_user"
  | "mass_downloads"
  | "high_severity_incidents"
  | "events_found"
  | "ghost_unprotected_privileged_accounts"
  | "active_unprotected_privileged_accounts"
  | "admin_unprotected_active_accounts"
  | "admin_unprotected_ghost_accounts"
  | "anonymous_link"
  | "ghost_anonymous_link"
  | "personal_ghost_access"
  | "external_ghost_access"
  | "internal_ghost_access"
  | "personal_access"
  | "external_access"
  | "public_access"
  | "data_exfiltration"
  | "misconfiguration_activity"
  | "unauthorized_data_access"
  // result finding types
  | "pb_cloud_mip_label_applied"
  | "pb_cloud_mip_label_labeled"
  | "pb_cloud_mip_label_conflict"
  | "pb_cloud_mip_label_failed";

export type FindingObjectType =
  | "Activity"
  | "Email"
  | "File"
  | "Bucket"
  | "Folder"
  | "Channel"
  | "Person"
  | "Group"
  | "Organization"
  | "Location"
  | "Record"
  | "Message"
  | "Link"
  | "Device"
  | "NamedEntity"
  | "AzStorage"
  | "Dynamics"
  | "SharepointWebsite"
  | "MsSql"
  | "Snowflake"
  | "FileShare"
  | "Dropbox"
  | "Confluence";

export interface FindingZAxis {
  type: FindingZAxisType;
  value: string | number;
}

export interface BaseFindingInput {
  service: DataSourceType;
  application: ApplicationType;
  type: FindingType;
  label_ids: string[];
  axis_w?: {
    type: FindingWAxisType;
    value: string;
  };
  axis_z: FindingZAxis;
}

export interface BaseMultipleFindingsInput {
  service: DataSourceType;
  application: ApplicationType;
  types: FindingType[];
  label_ids: string[];
  axis_w?: {
    type: FindingWAxisType;
    value: string;
  };
  axis_z: FindingZAxis;
}

export interface FindingsEntity {
  id: string;
  sessionId: number;
  serviceId: string;
  applicationId: ApplicationType;
  findingTypes: FindingType[];
  labelIds: string[];
  aggObjectType: FindingObjectType[];
  aggObjectUid: string;
  aggObjectName: string;
  objectType: FindingObjectType;
  objectUid: string;
  objectName: string;
  infoMap: any; //Record<string, string>;
  activityDate: string;
}

export const FindingsHelper = {
  to_sentence: (finding: FindingType): { pre: string; post: string } => {
    switch (finding) {
      case "sensitive_information":
      default:
        return {
          pre: "",
          post: "files were found",
        };
    }
  },
};
